import SodRiskScore from './SodRiskScore';

export default SodRiskScore;
